import { render, staticRenderFns } from "./ObjectCard.vue?vue&type=template&id=6f76503c"
import script from "./ObjectCard.vue?vue&type=script&lang=js"
export * from "./ObjectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports